import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { useUser } from '@lore/auth';
import { BuildingOfficeIcon, GlobeAltIcon } from '@heroicons/react/24/outline';
import { getDistanceFromLatLonInMiles } from '../../../components/User/utils';
import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import Loader from '../../../components/Loader';
import useProjectTags from '../../../hooks/useProjectTags';
import TagTypes from '../../../constants/TagTypes';
import TextIconGroup from '../../../components_profiles/TextIconGroup';

Participation.propTypes = {
  project: PropTypes.object.isRequired
};

export default function Participation(props) {
  const { project } = props;

  const currentUser = useUser();

  const creator = useConnect('user.byId', {
    id: project.data.creatorId
  });

  const projectInteractionTypes = useProjectTags(project, TagTypes.InteractionType);

  if (
    creator.state === PayloadStates.FETCHING ||
    projectInteractionTypes.state === PayloadStates.FETCHING
  ) {
    return (
      <div>
        <div className="text-sm text-cs-gray-500 font-semibold uppercase mb-2">
          Participation options
        </div>
        <Loader/>
      </div>
    );
  }

  const distance = getDistanceFromLatLonInMiles(creator.data, currentUser.data);

  const isInPerson = _.find(projectInteractionTypes.data, function(projectInteractionType) {
    return projectInteractionType.data.name === 'In-person';
  });

  const isVirtual = _.find(projectInteractionTypes.data, function(projectInteractionType) {
    return projectInteractionType.data.name === 'Virtual';
  });

  return (
    <div className="space-y-2">
      <div className="text-sm text-cs-gray-500">
        Participation options
      </div>
      <div className="flex space-x-6">
        {isInPerson && (
          <TextIconGroup
            icon={BuildingOfficeIcon}
            title="In-person"
            // subtitle={distance <= 1 ? '1 mile away' : `${distance} miles away`}
          />
        )}
        {isVirtual && (
          <TextIconGroup
            icon={GlobeAltIcon}
            title="Virtual"
            // subtitle={isInPerson ? undefined : distance <= 1 ? '1 mile away' : `${distance} miles away`}
          />
        )}
      </div>
    </div>
  );
}
